import graphql from "babel-plugin-relay/macro";

export const HomeContentQuery = graphql`
  query HomeContentQuery {
    pendingDocuments(showAll: false) {
      documents(first: 5) {
        totalCount
        edges {
          node {
            id
            pk
            name
            bloc {
              name
            }
            category {
              name
            }
            effectiveDate
            restricted
            legacyEffectiveDate
          }
        }
      }
    }
    documentsToReview {
      documents(first: 5) {
        totalCount
        edges {
          node {
            id
            pk
            name
            bloc {
              name
            }
            category {
              name
            }
            expirationDate
            restricted
          }
        }
      }
      buckets
    }
    myDocumentsToAcknowledge(first: 5) {
      totalCount
      edges {
        node {
          totalAcknowledged
          totalAssigned
          line {
            pk
            document {
              pk
              name
              hasAttachments
              effectiveDate
              legacyEffectiveDate
              restricted
            }
          }
        }
      }
    }
    recentlyRevisedDocuments {
      documents(first: 5) {
        totalCount
        edges {
          node {
            pk
            name
            bloc {
              name
            }
            category {
              name
            }
            revisedFromParent
            effectiveDate
            legacyEffectiveDate
            restricted
          }
        }
      }
      buckets
    }
    currentTenant {
      settings {
        customWelcomeContentShow
        customWelcomeContentPsa
      }
    }
  }
`;
